import { ECalculateStatus, ICalculateResult } from '../../types/calculate';
import { IApplicationState } from '../../types/redux';

export function selectCalculateResult(state: IApplicationState): ICalculateResult | null {
  return state.calculate.result;
}

export function selectCalculateStatus(state: IApplicationState): ECalculateStatus {
  return state.calculate.status;
}

export function selectCalculateStatusLoading(state: IApplicationState): boolean {
  return state.calculate.status === ECalculateStatus.Loading;
}
